export default "__VITE_ASSET__D9g7OIr1__"